export default __webpack_public_path__ + "static/media/lavanda.f27e62db.pdf";